import { useGetCountryCode } from "@/services/api-hooks/geo";
import { getCompanyLegalInfo } from "@/utils/legal";

export const useCompanyLegalInfo = () => {
  const { data: countryCode, isLoading } = useGetCountryCode();

  return {
    company: getCompanyLegalInfo(countryCode),
    isLoading,
  };
};
